// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()

require("bootstrap");
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

var hmb_key = sessionStorage.getItem('menu_ber');
var accordion_key = JSON.parse(sessionStorage.getItem('accordion'));
let value=[];
if (accordion_key!==null){
  for (var n=0; n<=accordion_key.length-1; n++){
    value.push(accordion_key[n])
  }
}


$(function() {
  $('.navbar-toggler').on('click', function () {
    $(this).toggleClass('closes');
    $('.mc-sidenav').toggleClass('closes');
    $('.mc-main-content').toggleClass('closes');
    if ($('.mc-sidenav').hasClass('closes')){
      sessionStorage.setItem('menu_ber','closes');
    }else{
      sessionStorage.removeItem('menu_ber');
    }
  });
});

$(function(){
  if (hmb_key=='closes'){
    $('.navbar-toggler').addClass('closes');
    $('.mc-sidenav').addClass('closes');
    $('.mc-main-content').addClass('closes');
  }
});



$(function(){
  $('.accordion-title').on('click',function(){
    $(this).next().slideToggle(250);
    $(this).toggleClass('open');
    var index = $('.accordion-title').index($(this));
    if ($(this).hasClass('open')){
      value.push(index);
      sessionStorage.setItem('accordion',JSON.stringify(value));
    }else{
      value = value.filter(function(item){
        return item !== index;
      });
      sessionStorage.setItem('accordion',JSON.stringify(value));
    }
  });
});

$(function(){
  if (accordion_key!==null){
    for (var n=0; n<=accordion_key.length-1; n++){
      $('.accordion-title').eq(accordion_key[n]).addClass('open').next().slideToggle();
    }
  }
});
